var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import i18next from "i18next";
import { BookModel } from "..";
import { normalizeField } from "../../../components/BookingFormPage/field-meta";
import { FormItemModelCollection } from "./FormItemModelCollection";
import { getAxiosInstance } from "../../../httpService";
import { encodeURI } from 'js-base64/base64';
var FormItemModel = /** @class */ (function (_super) {
    __extends(FormItemModel, _super);
    function FormItemModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormItemModel.getCollectionClass = function () {
        return FormItemModelCollection;
    };
    FormItemModel.prototype.getItemName = function (prefix, index) {
        var _a;
        if (prefix === void 0) { prefix = ""; }
        if (index === void 0) { index = null; }
        var entityName = this.get("entity_name");
        var nameList = [
            prefix,
            this.get("item_type_name")
        ];
        if (entityName !== "formGroup") {
            var tableName = this.get("entity_name") !== "formGroup" ? (_a = this.getField()) === null || _a === void 0 ? void 0 : _a.getTableName() : null;
            nameList.push(tableName);
            if (entityName !== "consent" && index !== null) {
                nameList.push("" + index);
            }
        }
        return nameList.filter(Boolean).join(".");
    };
    FormItemModel.prototype.consent = function () {
        return this.hasOne("consents", "consent");
    };
    FormItemModel.prototype.formField = function () {
        return this.hasOne("form_fields", "formField");
    };
    FormItemModel.prototype.formGroup = function () {
        return this.hasOne("form_groups", "formGroup");
    };
    FormItemModel.prototype.getNestedNameArray = function (parent) {
        return [
            "form_data",
            this.get("item_type_name"),
            parent,
        ].filter(Boolean);
    };
    Object.defineProperty(FormItemModel.prototype, "isConsent", {
        get: function () {
            return this.get("entity_name") === "consent";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormItemModel.prototype, "isFormGroup", {
        get: function () {
            return this.get("entity_name") === "formGroup";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormItemModel.prototype, "isFormField", {
        get: function () {
            return this.get("entity_name") === "formField";
        },
        enumerable: false,
        configurable: true
    });
    FormItemModel.prototype.getSaveParticipantCheckbox = function (form) {
        var _a, _b;
        if (!this.isConsent || !this.options.showSaveParticipants) {
            return [];
        }
        var isChecked = form.shouldSaveParticipant;
        var _c = {
            title: (!isChecked && ((_a = i18next.t("save_participant_consent.title_unchecked")) === null || _a === void 0 ? void 0 : _a.trim())) || i18next.t("save_participant_consent.title_checked"),
            children: (!isChecked && ((_b = i18next.t("save_participant_consent.description_unchecked")) === null || _b === void 0 ? void 0 : _b.trim())) || i18next.t("save_participant_consent.description_checked"),
        }, title = _c.title, children = _c.children;
        return [normalizeField({
                field_type_name: "checkbox",
                name: "additional_props.save_participant_data",
                title: title, children: children,
            }, {
                recommended: true,
                unique: true,
                order: 1000,
            })];
    };
    FormItemModel.prototype.getWrittenConsentCheckbox = function (form) {
        var _a, _b, _c, _d;
        if (!this.isConsent || !this.options.isAdminIntegration) {
            return [];
        }
        var isChecked = !!form.hasCoworkerConsent;
        var billRecipient = form.participants[form.billRecipientIndex] || {};
        var link = (this.options.integrationName ? (_b = (_a = getAxiosInstance(this.options.integrationName)) === null || _a === void 0 ? void 0 : _a.getDownloadConsentURL) === null || _b === void 0 ? void 0 : _b.call(_a, encodeURI(JSON.stringify(billRecipient))) : "") || "";
        var downloadConsentsFormLink = link ? "<a href=\"" + link + "\" target=\"_blank\">" + i18next.t("written_consent.download_link_label") + "</a>" : "";
        var _e = {
            title: (!isChecked && ((_c = i18next.t("written_consent.title_unchecked", { downloadConsentsFormLink: downloadConsentsFormLink })) === null || _c === void 0 ? void 0 : _c.trim())) || i18next.t("written_consent.title_checked", { downloadConsentsFormLink: downloadConsentsFormLink }),
            children: (!isChecked && ((_d = i18next.t("written_consent.description_unchecked")) === null || _d === void 0 ? void 0 : _d.trim())) || i18next.t("written_consent.description_checked"),
        }, title = _e.title, children = _e.children;
        return [normalizeField({
                field_type_name: "checkbox",
                name: "booking_data.coworker_confirms_consents",
                title: title, children: children,
            }, {
                getDynamicValue: function (_a) {
                    var value = _a.value;
                    return [{ key: "booking_data.coworker_confirms_consents", value: value }];
                }
            })];
    };
    FormItemModel.prototype.getField = function () {
        switch (this.get("entity_name")) {
            case "consent": return this.consent();
            case "formField": return this.formField();
            case "formGroup": return this.formGroup();
        }
    };
    FormItemModel.prototype.getFieldPaths = function () {
        switch (this.get("entity_name")) {
            case "consent": return [];
            case "formField": return ["form_data", this.getItemName()].join(".");
            case "formGroup": return this.formGroup().getFieldPaths();
        }
    };
    return FormItemModel;
}(BookModel));
export { FormItemModel };
